import React from 'react';
import { useAuth } from '../auth/AuthProvider';
import './AuthButtons.css';

function AuthButtons() {
  const { ready, authenticated, userLabel, login, register, logout } = useAuth();

  if (!ready) {
    return null;
  }

  if (authenticated) {
    return (
      <div className="auth-buttons" aria-live="polite">
        {userLabel ? <span className="auth-user">{userLabel}</span> : null}
        <button type="button" className="auth-btn auth-btn--ghost" onClick={logout}>
          Log out
        </button>
      </div>
    );
  }

  return (
    <div className="auth-buttons">
      <button type="button" className="auth-btn auth-btn--ghost" onClick={login}>
        Log in
      </button>
      <button type="button" className="auth-btn auth-btn--primary" onClick={register}>
        Register
      </button>
    </div>
  );
}

export default AuthButtons;
